import { Entity } from "@backstage/catalog-model";

export const useEntityCatalogSlug = ({ entity }: { entity: Entity }) => {
  if (
    !entity ||
    !entity.metadata ||
    !entity.metadata.namespace ||
    !entity.kind
  ) {
    return "catalog";
  }

  const namespace = entity.metadata.namespace.toLowerCase();
  const kind = entity.kind.toLowerCase();
  const name = entity.metadata.name;

  return `catalog/${namespace}/${kind}/${name}`;
};
